import React from 'react';

const GalleryImage = ({ src, alt, featured = false }) => {
    return (
        <div className={`relative group overflow-hidden rounded-2xl ${featured ? 'col-span-2 row-span-2' : ''}`}>
            <img
                src={src}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                alt={alt}
            />
            {featured && (
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors flex items-center justify-center opacity-0 group-hover:opacity-100">
                    <button className="bg-white text-black px-6 py-2 rounded-full text-xs font-bold uppercase tracking-widest">
                        View Post
                    </button>
                </div>
            )}
        </div>
    );
};

export default GalleryImage;
